export const SEQUENCE_ANNOTATION = 'SEQUENCE_ANNOTATION';
export const SEQUENCE_TAG = 'SEQUENCE_TAG';
export const SAMPLE_ANNOTATION = 'SAMPLE_ANNOTATION';

export const BASIC_TYPES = [
    SEQUENCE_ANNOTATION,
    SEQUENCE_TAG,
    SAMPLE_ANNOTATION
];
